import { useEffect, useRef, useCallback } from 'react';

const useBroadcastChannel = (channelName, handlers) => {
    const broadcastChannelRef = useRef(null);

    useEffect(() => {
        try {
            const channel = new BroadcastChannel(channelName);
            broadcastChannelRef.current = channel;

            channel.onmessage = (event) => {
                const { type, data, source } = event.data;

                if (source === 'websocket') {
                    return;
                }

                switch (type) {
                    case 'change_slots':
                        break;
                    case 'player_update':
                        handlers.onPlayerUpdate?.(data);
                        break;
                    case 'player_create':
                        handlers.onPlayerCreate?.(data);
                        break;
                    case 'game_end':
                        handlers.onGameEnd?.(data);
                        break;
                    case 'clear_all':
                        handlers.onClearAll?.();
                        break;
                }
            };

            return () => {
                channel.close();
            };
        } catch {
        }
    }, [channelName]);

    const sendMessage = useCallback((type, data) => {
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage({
                type,
                data,
                timestamp: Date.now(),
                source: 'websocket'
            });
        }
    }, []);

    return { sendMessage };
};

export default useBroadcastChannel;
